module.exports = __webpack_public_path__ + "img/file-upload-pdf-doc.fb76b0de.svg";